<div class="">
  <ng-content></ng-content>
  <button class="btn common__btn" style="margin-bottom: 0" (click)="create()" *ngIf="isCreate">
    Tạo mới
  </button>
  <!-- <div class="mt-2" *ngIf="isTotal">
    <div class="d-flex justify-content-between align-items-center">
      <span style="margin-left: 5px;">Có {{total | number}} kết quả</span>
    </div>
  </div> -->
</div>